import { Action, createReducer, on } from "@ngrx/store";

import { StoryDeprecated } from "@hermes/api-model-editorial";

import {
    fetchStory,
    fetchStoryFailure,
    fetchStorySuccess,
    fetchHomepageStorySuccess,
} from "../actions/story.action";

export const storyFeatureKey = "story";

export interface StoryState {
    story: StoryDeprecated | undefined;
    loading: boolean;
}

export const initialStoryState: StoryState = {
    story: undefined,
    loading: false,
};

export const reducer = (state: StoryState, action: Action): StoryState =>
    storyReducer(state, action);

export const fetchStoryReducer = (
    state: StoryState,
    _action: ReturnType<typeof fetchStory>,
): StoryState => ({
    ...state,
    loading: true,
});

export const fetchStorySuccessReducer = (
    state: StoryState,
    action: ReturnType<
        typeof fetchStorySuccess | typeof fetchHomepageStorySuccess
    >,
): StoryState => ({
    ...state,
    loading: false,
    story: action.story,
});

export const fetchStoryFailureReducer = (
    state: StoryState,
    _action: ReturnType<typeof fetchStoryFailure>,
): StoryState => ({
    ...state,
    loading: false,
    story: undefined,
});

const storyReducer = createReducer(
    initialStoryState,
    on(fetchStory, fetchStoryReducer),
    on(fetchStorySuccess, fetchStorySuccessReducer),
    on(fetchHomepageStorySuccess, fetchStorySuccessReducer),
    on(fetchStoryFailure, fetchStoryFailureReducer),
);
